var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic-form-detail-wrapper"},[_c('dynamic-form-wrapper',{attrs:{"id":_vm.$route.params.id,"viewType":"dynamicFormDetail","showHistory":true,"onBack":function () { return _vm.$router.go(-1); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }